import script from "./NavbarSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarSection.vue?vue&type=script&setup=true&lang=js"

import "./NavbarSection.vue?vue&type=style&index=0&id=2e51d744&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e51d744"]])

export default __exports__